import axios from 'axios';
import BookFlightRequestInterface from 'models/flight/bookFlightRequest.interface';
import FlightPriceResponseInterface from 'models/flight/flightPriceResponse.interface';
import GetAirPriceDiscountRequestInterface from 'models/flight/getAirPriceRequest.interface';
import { Maybe } from 'models/types';
import urls from 'utils/urls';

export const getDiscountPrice = async (
  payload: GetAirPriceDiscountRequestInterface
): Promise<FlightPriceResponseInterface> => {
  return axios
    .post(urls.discountAirPrice, payload)
    .then((res) => {
      return res.data.response;
    })
    .catch((ex) => {
      throw ex;
    });
};

export const discountBookFlightService = async (payload: BookFlightRequestInterface): Promise<Maybe<any>> => {
  const response = await axios.post(urls.discountAirBook, payload);
  if (response && response.status === 200 && response.data.success) return response.data.response;
  return null;
};
